import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import OurValuesSliderBuilder from 'components/AboutUs/OurValuesSliderBuilder'
import parser from 'html-react-parser'

export default function Slider1({data}) {
    const {slider1Text, slider1Title, slider1Slides} = data
    return (
        <div className='about-our-value-wrap'>
            <div className='container sm-container'>
                <div className='row'>
                    <div className='col-md-12 heading-head-sec text-center'>
                        <figure className='abt-origins-icon'>
                            <StaticImage
                                src='../../../images/our-value-icon.png'
                                alt='image'
                            />
                        </figure>
                        <h2 className='heading-level-2 blue-color'>{slider1Title && parser(slider1Title)}</h2>
                        <p>{slider1Text && parser(slider1Text)}</p>
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='abt-value-slider-sec w-slick-image-arrow font-white text-center'>
                            <OurValuesSliderBuilder slider1Slides={slider1Slides} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
